import * as React from 'react';
import { ModalWindow } from '../../../../modal';
import { Checkbox } from '../../../../checkbox';
import { Button } from '../../../../button';
import { useDeviceType } from '../../../../responsive';
import { getStyles } from './styles';
import { useMultiSelectMobileModalController } from './hooks/useMultiSelectMobileModalController';
export function MultiSelectMobileModal(props) {
  var open = props.open,
    onClose = props.onClose,
    options = props.options,
    onChange = props.onChange,
    title = props.title,
    name = props.name;
  var deviceType = useDeviceType();
  var styles = getStyles(deviceType);
  var _useMultiSelectMobile = useMultiSelectMobileModalController(props),
    value = _useMultiSelectMobile.value,
    handleOptionChange = _useMultiSelectMobile.handleOptionChange,
    allOptionLabel = _useMultiSelectMobile.allOptionLabel,
    handleAllOptionChange = _useMultiSelectMobile.handleAllOptionChange;
  var handleApply = function handleApply() {
    if (value !== props.value && onChange) {
      onChange(value || []);
    }
    onClose();
  };
  var bindHandleOptionChange = function bindHandleOptionChange(index) {
    return function () {
      return handleOptionChange(index);
    };
  };
  return /*#__PURE__*/React.createElement(ModalWindow, {
    fixed: true,
    width: 648,
    open: open,
    onClose: onClose,
    title: title,
    footer: /*#__PURE__*/React.createElement("div", {
      className: styles['footer-buttons']
    }, /*#__PURE__*/React.createElement(Button, {
      theme: "fill_secondary",
      onClick: onClose
    }, "\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C"), /*#__PURE__*/React.createElement(Button, {
      theme: "fill_primary",
      onClick: handleApply
    }, "\u041F\u0440\u0438\u043C\u0435\u043D\u0438\u0442\u044C"))
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['content'],
    role: "listbox"
  }, allOptionLabel && /*#__PURE__*/React.createElement(Checkbox, {
    value: "allOption",
    checked: (value === null || value === void 0 ? void 0 : value.length) === options.length,
    label: allOptionLabel,
    onChange: handleAllOptionChange,
    role: "option"
  }), options.map(function (option, index) {
    var optionValue = option.value;
    var key = String(optionValue);
    return /*#__PURE__*/React.createElement(Checkbox, {
      key: key,
      name: name,
      value: key,
      checked: (value || []).includes(optionValue),
      label: option.label,
      onChange: bindHandleOptionChange(index),
      role: "option"
    });
  })));
}